import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import SearchField from "../../Components/Forms/SearchField";
import Pagination from "./../../Components/Pagination";
import api from '../../api/api';
import Loader from '../../Components/Loader';
import { MyContext } from '../../Components/Context';

export default function Proprietaires() {
    const [owners, setOwners] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);
    const { actifItem, setActifItem } = useContext(MyContext);


    const navigate = useNavigate();

    useEffect(() => {
        const getAllOwners = async () => {
            setLoading(true);
            try {
                const response = await api.get('/owners', {
                    params: {
                        page: currentPage,
                        limit: 10,
                        search: search
                    }
                });
                
                setOwners(response.data.owners);
                setTotalPages(response.data.totalPages);
                setActifItem('Proprietaires')
                
            } catch (err) {
                console.error('Erreur lors de la récupération des propriétaires:', err);
            }
            setLoading(false);
        }
        getAllOwners();
    }, [currentPage, search]);

    return (
        <div className="px-4 md:px-8">
            <SearchField onSearch={(term) => setSearch(term)} />
            <div className="items-start justify-between md:flex">
                <div className="max-w-lg">
                    <h3 className="text-xl font-bold text-gray-800 dark:text-gray-200 sm:text-2xl">Propriétaires</h3>
                    {/* <p className="mt-2 text-gray-600">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> */}
                </div>
                <div className="mt-3 md:mt-0">
                    {/* <button
                        className="inline-block px-4 py-2 font-medium text-white duration-150 bg-indigo-600 rounded-lg hover:bg-indigo-500 active:bg-indigo-700 md:text-sm"
                        onClick={() => { navigate('/proprietaire/creation') }}
                    >
                        Ajouter
                    </button> */}
                </div>
            </div>
            <div className="relative mt-12 overflow-auto h-max">
                {loading ? (
                    <Loader/>
                ) : owners.length === 0 ? (
                    <div className="flex items-center justify-center h-64 text-center text-gray-600">
                        <p className="text-xl font-medium">Aucun propriétaire trouvé.</p>
                    </div>
                ) : (
                    <table className="w-full my-5 overflow-x-scroll">
                        <thead className="font-medium text-gray-600 bg-gray-200 border-b dark:bg-gray-800 dark:border-gray-600">
                            <tr>
                                <th className="w-1/4 px-6 py-4 font-bold text-left text-gray-600 uppercase dark:text-gray-200">Nom</th>
                                <th className="w-1/4 px-6 py-4 font-bold text-left text-gray-600 uppercase dark:text-gray-200">Prenom</th>
                                <th className="w-1/4 px-6 py-4 font-bold text-left text-gray-600 uppercase dark:text-gray-200">Email</th>
                                <th className="w-1/4 px-6 py-4 font-bold text-left text-gray-600 uppercase dark:text-gray-200">Date</th>
                                <th className="w-1/4 px-6 py-4 font-bold text-left text-gray-600 uppercase dark:text-gray-200">Telephone</th>
                                <th className="w-1/4 px-6 py-4 font-bold text-left text-gray-600 uppercase dark:text-gray-200">Verifié</th>
                                <th className="w-1/4 px-6 py-4 font-bold text-left text-gray-600 uppercase dark:text-gray-200">Supendu</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 divide-y">
                            {owners.map((owner) => (
                                <tr key={owner.id} onClick={() => navigate(`/proprietaires/details/${owner.id}`)} className="duration-300 cursor-pointer hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-200 hover:dark:text-gray-700 ">
                                    {console.log('Le propriétaire est :',owner)}
                                    <td className="px-6 py-4 border-b border-gray-200 dark:border-gray-600">
                                        <div className="flex items-center">
                                            <img alt={`Profil de ${owner.client.firstname}`} src={owner.client.picture ? `${process.env.REACT_APP_API_PICTURE_URL}${owner.client.picture}` : "https://randomuser.me/api/portraits/men/86.jpg"} className="w-10 h-10 mr-4 rounded-full" />
                                            <span>{owner.client.lastname}</span>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 truncate border-b border-gray-200 dark:border-gray-600">{owner.client.firstname}</td>
                                    <td className="px-6 py-4 truncate border-b border-gray-200 dark:border-gray-600">{owner.client.email}</td>
                                    <td className="px-6 py-4 border-b border-gray-200 dark:border-gray-600">{new Date(owner.createdAt).toLocaleDateString()}</td>
                                    <td className="px-6 py-4 border-b border-gray-200 dark:border-gray-600">{owner.client.phone}</td>
                                    <td className="px-6 py-4 border-b border-gray-200 dark:border-gray-600">
                                        <span className={`px-4 py-1 ${owner.isVerified ? 'bg-green-200 text-green-600' : 'bg-gray-200 text-gray-600'} rounded-xl`}>
                                            {owner.isVerified ? 'Oui' : 'Non'}
                                        </span>
                                    </td>

                                    <td className="px-6 py-4 border-b border-gray-200 dark:border-gray-600">
                                        <span className={`px-4 py-1 ${owner.suspened ? 'bg-green-200 text-red-600' : 'bg-gray-200 text-green-600'} rounded-xl`}>
                                            {owner.suspened ? 'Oui' : 'Non'}
                                        </span>
                                    </td>
                                    
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
            {owners.length > 0 && (
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                />
            )}
        </div>
    );
}
